import { LIMITED_PHONE_COUNTRY_CODE } from '../../../constants';
import { EmailFormValues, PhoneFormValues } from './types';

export const CITIZENSHIP_OPTIONS = [
  { label: 'United States', value: 'United States' },
  { label: 'Permanent Resident', value: 'Permanent Resident' },
  { label: 'Visa', value: 'Visa' },
  { label: 'Other', value: 'Other' },
];

export const GENDER_OPTIONS = [
  { label: 'Male', value: 'M' },
  { label: 'Female', value: 'F' },
  { label: 'Non-Binary', value: 'N' },
  { label: 'Prefer not to Disclose', value: 'O' },
];

// [MCV-1905] 'None' (value '') is how a visa field is cleared: the selects are not
// clearable, and the save sends '' as null. It is also the default for a provider with
// no visa on file, which used to show (and save) the first real option.
export const VISA_STATUS_OPTIONS = [
  { label: 'None', value: '' },
  { label: 'Active', value: 'Active' },
  { label: 'Pending', value: 'Pending' },
  { label: 'Expiring', value: 'Expiring Soon' },
  { label: 'Expired', value: 'Expired' },
];

export const VISA_TYPE_OPTIONS = [
  { label: 'None', value: '' },
  { label: 'H-1B', value: 'H-1B' },
  { label: 'L-1', value: 'L-1' },
  { label: 'O-1', value: 'O-1' },
  { label: 'E-2', value: 'E-2' },
  { label: 'TN', value: 'TN' },
];

export const LANGUAGES = [
  { label: 'Afrikaans', value: 'af' },
  { label: 'Albanian', value: 'sq' },
  { label: 'Arabic', value: 'ar' },
  { label: 'Armenian', value: 'hy' },
  { label: 'Basque', value: 'eu' },
  { label: 'Bengali', value: 'bn' },
  { label: 'Bulgarian', value: 'bg' },
  { label: 'Catalan', value: 'ca' },
  { label: 'Cambodian', value: 'km' },
  { label: 'Chinese (Mandarin)', value: 'zh' },
  { label: 'Croatian', value: 'hr' },
  { label: 'Czech', value: 'cs' },
  { label: 'Danish', value: 'da' },
  { label: 'Dutch', value: 'nl' },
  { label: 'English', value: 'en', isFixed: true },
  { label: 'Estonian', value: 'et' },
  { label: 'Fiji', value: 'fj' },
  { label: 'Finnish', value: 'fi' },
  { label: 'French', value: 'fr' },
  { label: 'Georgian', value: 'ka' },
  { label: 'German', value: 'de' },
  { label: 'Greek', value: 'el' },
  { label: 'Gujarati', value: 'gu' },
  { label: 'Hebrew', value: 'he' },
  { label: 'Hindi', value: 'hi' },
  { label: 'Hungarian', value: 'hu' },
  { label: 'Icelandic', value: 'is' },
  { label: 'Indonesian', value: 'id' },
  { label: 'Irish', value: 'ga' },
  { label: 'Italian', value: 'it' },
  { label: 'Japanese', value: 'ja' },
  { label: 'Javanese', value: 'jw' },
  { label: 'Korean', value: 'ko' },
  { label: 'Latin', value: 'la' },
  { label: 'Latvian', value: 'lv' },
  { label: 'Lithuanian', value: 'lt' },
  { label: 'Macedonian', value: 'mk' },
  { label: 'Malay', value: 'ms' },
  { label: 'Malayalam', value: 'ml' },
  { label: 'Maltese', value: 'mt' },
  { label: 'Maori', value: 'mi' },
  { label: 'Marathi', value: 'mr' },
  { label: 'Mongolian', value: 'mn' },
  { label: 'Nepali', value: 'ne' },
  { label: 'Norwegian', value: 'no' },
  { label: 'Persian', value: 'fa' },
  { label: 'Polish', value: 'pl' },
  { label: 'Portuguese', value: 'pt' },
  { label: 'Punjabi', value: 'pa' },
  { label: 'Quechua', value: 'qu' },
  { label: 'Romanian', value: 'ro' },
  { label: 'Russian', value: 'ru' },
  { label: 'Samoan', value: 'sm' },
  { label: 'Serbian', value: 'sr' },
  { label: 'Slovak', value: 'sk' },
  { label: 'Slovenian', value: 'sl' },
  { label: 'Spanish', value: 'es' },
  { label: 'Swahili', value: 'sw' },
  { label: 'Swedish', value: 'sv' },
  { label: 'Tamil', value: 'ta' },
  { label: 'Tatar', value: 'tt' },
  { label: 'Telugu', value: 'te' },
  { label: 'Thai', value: 'th' },
  { label: 'Tibetan', value: 'bo' },
  { label: 'Tonga', value: 'to' },
  { label: 'Turkish', value: 'tr' },
  { label: 'Ukrainian', value: 'uk' },
  { label: 'Urdu', value: 'ur' },
  { label: 'Uzbek', value: 'uz' },
  { label: 'Vietnamese', value: 'vi' },
  { label: 'Welsh', value: 'cy' },
  { label: 'Xhosa', value: 'xh' },
  { label: 'American Sign Language', value: 'asl' },
];

export const PROVIDER_TYPE_OPTIONS = [
  { value: 'MD', label: 'Doctor of Medicine' },
  { value: 'DO', label: 'Doctor of Osteopathic Medicine' },
];

export const PROVIDER_CAT_OPTIONS = [{ value: '1', label: 'Physician' }];

export const PHONE_TYPE_OPTIONS = [
  {
    value: 'Mobile',
    label: 'Mobile',
  },
  {
    value: 'Fax',
    label: 'Fax',
  },
  {
    value: 'Office',
    label: 'Office',
  },
  {
    value: 'Home',
    label: 'Home',
  },
];

export const EMPTY_PHONE_FORM: PhoneFormValues = {
  phoneType: PHONE_TYPE_OPTIONS[0],
  primaryFlag: false,
  phoneNum: '',
  countryCode: LIMITED_PHONE_COUNTRY_CODE[0],
};

export const EMPTY_EMAIL_FORM: EmailFormValues = {
  emailAddress: '',
  primaryFlag: false,
};
